namespace Gordic.Utils {
    export type gzSources = "tango" | "app" | "logo" | "flags" | "help";
    export function gz(source: gzSources | string, file?: string) {
        var url = `gin/gz.ashx/${encodeURIComponent(source)}` // obsolete in 490
        //var url = `gz/${encodeURIComponent(source)}` //TODO: 490

        if (file == null) {
            let splitted = source.split(":");
            if (splitted.length > 1)
                return gz(splitted[0] as gzSources, splitted[1])
            else
                ;
        } else url += '/' + file.split('/').map(part => encodeURIComponent(part)).join('/');
        return (window as any).TranslateUrlForCall != null ? (window as any).TranslateUrlForCall("~/"+url) : url;
    };
}

interface JQueryStatic {
    gz(source: Gordic.Utils.gzSources | string, file?: string): string;
    gz(source: string): string;
}

(window as any).$.gz = Gordic.Utils.gz;

//Actual registration is in gui.webcontrols/Scripts/utils/Utils.ts, because here is not JQuery